import request from '@/utils/request'
const apiPath = '/live/liveBlessingBagSignUp'

const liveBlessingBagSignUpApi = {
  /**
   * 查询抽奖记录列表
   */
  fetchList(query) {
    return request.get(`${apiPath}/tee/list`, { params: query })
  },
  /**
   * 获取统计人数
   */
  getCount(query) {
    return request.get(`${apiPath}/tee/getCount`, { params: query })
  },
}

export default liveBlessingBagSignUpApi






